export default __webpack_public_path__ + "images/c5a6f2991302bd669ab247d26c2da961.svg";